export const CALLS_STORE_NAME = 'CallsStore';

export const SOURCE_END_CALL = {
  UNLOAD_WINDOW: 'UNLOAD_WINDOW',
  BUTTON_HANGUP: 'BUTTON_HANGUP',
  ON_SOCKET_CONN: 'ON_SOCKET_CONN',
  KICKOUT: 'KICKOUT',
  USER_LOGOUT: 'USER_LOGOUT',
}

export const KICKOUT_TYPE = {
  SINGLE_USER: 'SINGLE_USER',
  STUDENTS: 'ALL_STUDENTS',
  END_CALL: 'END_CALL'
}

export const COMMAND_TYPE = {
  KICKOUT: 'KICKOUT',
  UNKICKOUT: 'UNKICKOUT',
  MUTE: 'MUTE',
  UNMUTE: 'UNMUTE',
  LOCK: 'LOCK',
  UNLOCK: 'UNLOCK',
  MUTE_ALL: 'MUTE_ALL',
  UNMUTE_ALL: 'UNMUTE_ALL',
  HANGUP: 'HANGUP'
}


//-- API for Back
export const CALLS_API = {
  GET_ACTIVE_CALL: 'call/active',
  START_CALL: 'call/',
  END_CALL: 'call/{meetingId}',
  GET_CALL_BY_ID: 'call/{meetingId}',
  CALL_TEACHERS_ACTIVE: 'call/teachers/active',
  COMMAND: 'call/command',
  GET_CALL_USERS: 'call/users',
  GET_CURRENT_CALL: 'call/current/{meetingId}',
  UPDATE_CURRENT_CALL: 'call/current',
  UPDATE_USER_CURRENT_CALL: 'call/current/user/{meetingId}',
  MUTE_CALL: 'call/current/mute/{meetingId}',
  LOCK_CALL: 'call/current/lock/{meetingId}',
  LIVE_CALLS: 'call/live?meetings={meetings}',
  CALL_JOIN: 'call/{meetingId}/join',
}

export enum API_VARIABLES {
  MEETING_ID = '{meetingId}',
  MEETINGS = '{meetings}',
  STUDENT_ID = '{personId}',
  CLASS_ID = '{classId}',
  SERVICE = '{service}'
}

//-- Events
export const CALLS_EVENTS = {
  CLICK_CALL_START: 'CLICK_CALL_START',                 //-- From menu - Select Option Call
  CALL_STARTED: 'CALL_STARTED',                         //-- Called Initiated
  CREATE_CALL_COMMAND: 'CREATE_CALL_COMMAND',           //-- Create command for a Call
  PARTICIPANT_CHANGED: 'PARTICIPANT_CHANGED',
  SHOW_SPLASH: 'SHOW_SPLASH',
  HIDE_SPLASH: 'HIDE_SPLASH',
  SET_AGENT: 'SET_AGENT',
  UPDATE_AGENT: 'UPDATE_AGENT',
  CALLS_CHANGE_TIME: 'CALLS_CHANGE_TIME',
  ON_CHANGE_MUTE_DEVICE: 'ON_CHANGE_MUTE_DEVICE',
  ON_NUMBER_PARTICIPANTS_CHANGED: 'ON_NUMBER_PARTICIPANTS_CHANGED',
}

export const ACTIONS = {
  START_CALL: 'startCall',
  END_CALL: 'endCall',
  MUTE_CALL: 'muteCall',
  ENABLE_CAMERA: 'enableCamera',
  GET_CALL_MEMBERS: 'getCallMembers',
  GET_CALL_AUDIO_DEVICES: 'getAudioTracks',
  GET_CALL_VIDEO_DEVICES: 'getVideoTracks',
  SET_AUDIO_DEVICE: 'changeAudioDevice',
  SET_VIDEO_DEVICE: 'changeVideoDevice',
  SET_IS_DEVICE_CHANGE: 'changeIsDeviceChange',
  SET_AGENT: 'setAgentA',
  UPDATE_AGENT: 'updateAgentA',

}

export const MUTATIONS = {
  ON_CALL: 'updateIsOnCall',
  UPDATE_CALL_CONF: 'updateCallConf',
  ON_MUTED: 'updateMicMuted',
  UPDATE_DEVICE_INFO: 'updateDeviceInfo',
  UPDATE_SIP: 'updateSip',
  UPDATE_AUDIO_SRC_ID: 'updateAudioSrc',
  UPDATE_AUDIO_OUTPUT_SRC_ID: 'updateAudioOutput',
  UPDATE_VIDE_SRC_ID: 'updateVideoSrc',
  CLEAN_CALL: 'cleanCall',
  UPDATE_MEET: 'updateMeet',
  SET_MEET: 'setMeet',
  UPDATE_PROCESSING: 'updateProcessing',
  UPDATE_LOCAL_TIME: 'updateLocalTime',
  MUTE_LOCAL: 'muteLocal',
  UPDATE_AGENT: 'updateAgent',
  SET_AGENT: 'setAgent',


  END_CALL: 'cleanCallStarted',
  ON_CAMERA: 'updateCameraEnabled',
  SET_CLASS_MEMBERS: 'updateClassMembers',
  CALL_AUDIO_DEVICES: 'updateCallAudioDevices',
  CALL_VIDEO_DEVICES: 'updateCallVideoDevices',
  SET_INCOMING_CALL: 'setIncomingCall',
  CLEAN_INCOMING_CALL: 'cleanIncomingCall',
  ON_VIDEO_SCREEN: 'updateVideoScreenEnabled',
  SET_AUDIO_DEVICE: 'updateAudioDevice',
  SET_VIDEO_DEVICE: 'updateVideoDevice',
  SET_IS_AUDIO_CHANGE: 'updateIsAudioChange',
  SET_IS_VIDEO_CHANGE: 'updateIsVideoChange',
  SET_CONFERENCE: 'updateConference',
  ON_JITSI_INIT_CALL: 'jitsiInitCall',
  UPDATE_PARTICIPANTS: 'updateParticipant',
  REMOVE_PARTICIPANT: 'removeParticipant',
  CALL_AUDIO_OUTPUT_DEVICES: 'updateCallAudioOutputDevices',
  SET_AUDIO_OUTPUT_DEVICE: 'updateAudioOutputDevice',
  SET_IS_AUDIOOUTPUT_CHANGE: 'updateIsAudioOutputChange',
}

export const _CALLS_STORE = {
  NAME: CALLS_STORE_NAME,
  MUTATIONS: {
    ON_CALL: `${CALLS_STORE_NAME}/${MUTATIONS.ON_CALL}`,
    UPDATE_CALL_CONF: `${CALLS_STORE_NAME}/${MUTATIONS.UPDATE_CALL_CONF}`,
    ON_MUTE: `${CALLS_STORE_NAME}/${MUTATIONS.ON_MUTED}`,
    UPDATE_DEVICE_INFO: `${CALLS_STORE_NAME}/${MUTATIONS.UPDATE_DEVICE_INFO}`,
    UPDATE_SIP: `${CALLS_STORE_NAME}/${MUTATIONS.UPDATE_SIP}`,
    UPDATE_AUDIO_SRC_ID: `${CALLS_STORE_NAME}/${MUTATIONS.UPDATE_AUDIO_SRC_ID}`,
    UPDATE_VIDE_SRC_ID: `${CALLS_STORE_NAME}/${MUTATIONS.UPDATE_VIDE_SRC_ID}`,
    UPDATE_AUDIO_OUTPUT_SRC_ID: `${CALLS_STORE_NAME}/${MUTATIONS.UPDATE_AUDIO_OUTPUT_SRC_ID}`,
    CLEAN_CALL: `${CALLS_STORE_NAME}/${MUTATIONS.CLEAN_CALL}`,
    UPDATE_MEET: `${CALLS_STORE_NAME}/${MUTATIONS.UPDATE_MEET}`,
    SET_MEET: `${CALLS_STORE_NAME}/${MUTATIONS.SET_MEET}`,
    UPDATE_PROCESSING: `${CALLS_STORE_NAME}/${MUTATIONS.UPDATE_PROCESSING}`,
    UPDATE_LOCAL_TIME: `${CALLS_STORE_NAME}/${MUTATIONS.UPDATE_LOCAL_TIME}`,
    MUTE_LOCAL: `${CALLS_STORE_NAME}/${MUTATIONS.MUTE_LOCAL}`,
    SET_AGENT: `${CALLS_STORE_NAME}/${MUTATIONS.SET_AGENT}`,
    UPDATE_AGENT: `${CALLS_STORE_NAME}/${MUTATIONS.UPDATE_AGENT}`,

    //-- Jitsi
    ON_CAMERA: `${CALLS_STORE_NAME}/${MUTATIONS.ON_CAMERA}`,
    END_CALL: `${CALLS_STORE_NAME}/${MUTATIONS.END_CALL}`,
    SET_INCOMING_CALL: `${CALLS_STORE_NAME}/${MUTATIONS.SET_INCOMING_CALL}`,
    CLEAN_INCOMING_CALL: `${CALLS_STORE_NAME}/${MUTATIONS.CLEAN_INCOMING_CALL}`,
    ON_VIDEO_SCREEN: `${CALLS_STORE_NAME}/${MUTATIONS.ON_VIDEO_SCREEN}`,
    SET_AUDIO_DEVICE: `${CALLS_STORE_NAME}/${MUTATIONS.SET_AUDIO_DEVICE}`,
    SET_VIDEO_DEVICE: `${CALLS_STORE_NAME}/${MUTATIONS.SET_VIDEO_DEVICE}`,
    SET_IS_AUDIO_CHANGE: `${CALLS_STORE_NAME}/${MUTATIONS.SET_IS_AUDIO_CHANGE}`,
    SET_IS_VIDEO_CHANGE: `${CALLS_STORE_NAME}/${MUTATIONS.SET_IS_VIDEO_CHANGE}`,
    SET_CONFERENCE: `${CALLS_STORE_NAME}/${MUTATIONS.SET_CONFERENCE}`,
    CALL_AUDIO_DEVICES: `${CALLS_STORE_NAME}/${MUTATIONS.CALL_AUDIO_DEVICES}`,
    CALL_VIDEO_DEVICES: `${CALLS_STORE_NAME}/${MUTATIONS.CALL_VIDEO_DEVICES}`,
    ON_JITSI_INIT_CALL: `${CALLS_STORE_NAME}/${MUTATIONS.ON_JITSI_INIT_CALL}`,
    UPDATE_PARTICIPANTS: `${CALLS_STORE_NAME}/${MUTATIONS.UPDATE_PARTICIPANTS}`,
    REMOVE_PARTICIPANT: `${CALLS_STORE_NAME}/${MUTATIONS.REMOVE_PARTICIPANT}`,
    CALL_AUDIO_OUTPUT_DEVICES: `${CALLS_STORE_NAME}/${MUTATIONS.CALL_AUDIO_OUTPUT_DEVICES}`,
    SET_AUDIO_OUTPUT_DEVICE: `${CALLS_STORE_NAME}/${MUTATIONS.SET_AUDIO_OUTPUT_DEVICE}`,
    SET_IS_AUDIOOUTPUT_CHANGE: `${CALLS_STORE_NAME}/${MUTATIONS.SET_IS_AUDIOOUTPUT_CHANGE}`,
  },
  ACTIONS: {
    SET_AGENT: `${CALLS_STORE_NAME}/${ACTIONS.SET_AGENT}`,
    UPDATE_AGENT: `${CALLS_STORE_NAME}/${ACTIONS.UPDATE_AGENT}`,
  }
}
